// extracted by mini-css-extract-plugin
export default {"color":"Color_color__hIDBy","colorText":"Color_colorText__5ixkd"};